import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  Users,
  ShoppingCart,
  Calendar,
  CalendarX,
  Star,
  Settings,
  LogOut,
  X,
  Tag,
  Mail,
} from 'lucide-react';

const navigation = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Buchungskalender', href: '/bookings-calendar', icon: Calendar },
  { name: 'Fotoboxen', href: '/inventory', icon: Package },
  { name: 'Kunden', href: '/customers', icon: Users },
  { name: 'Bestellungen', href: '/orders', icon: ShoppingCart },
  { name: 'Rabattcodes', href: '/discount-codes', icon: Tag },
  { name: 'Newsletter', href: '/newsletter', icon: Mail },
  { name: 'Sperrtage', href: '/blocked-dates', icon: CalendarX },
  { name: 'Features', href: '/features', icon: Star },
  { name: 'Einstellungen', href: '/settings', icon: Settings },
];

export function Sidebar({ onLogout, user, isOpen, onClose }) {
  return (
    <div
      className={`
        flex flex-col h-full w-60 bg-[#FFFEFA] border-r border-gray-200
        fixed lg:static inset-y-0 left-0 z-50
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}
    >
      {/* Logo & Close Button */}
      <div className="px-6 py-5 border-b border-gray-200 flex items-center justify-between">
        <div className="flex items-center justify-center flex-1">
          <img
            src="/assets/logo.png"
            alt="You.Me. Photo"
            className="h-16 w-auto object-contain"
          />
        </div>
        {/* Mobile close button */}
        <button
          onClick={onClose}
          className="lg:hidden p-2 text-gray-400 hover:text-gray-600 transition-colors absolute right-4"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            onClick={() => onClose?.()}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            {item.name}
          </NavLink>
        ))}
      </nav>

      {/* User Info & Logout */}
      <div className="border-t border-gray-200 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-sm font-medium">
              {user?.username?.charAt(0).toUpperCase() || 'A'}
            </div>
            <div className="text-sm">
              <div className="font-medium text-gray-900">{user?.username || 'Admin'}</div>
            </div>
          </div>
          <button
            onClick={onLogout}
            className="p-2 text-gray-400 hover:text-error transition-colors"
            title="Abmelden"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
